/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemListFilters_data = {
    readonly filters: ReadonlyArray<{
        readonly key: string;
        readonly " $fragmentRefs": FragmentRefs<"ListPageFilter_filter">;
    }> | null;
    readonly " $refType": "ItemListFilters_data";
};
export type ItemListFilters_data$data = ItemListFilters_data;
export type ItemListFilters_data$key = {
    readonly " $data"?: ItemListFilters_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemListFilters_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemListFilters_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Filter",
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListPageFilter_filter"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemList",
  "abstractKey": null
};
(node as any).hash = 'd34e0d561a9cc364b21cff49e2b94f49';
export default node;
